import PropTypes from 'prop-types';
import { Dialog, Stack } from '@etg/wings';
import { BoundNew } from '@eti/types';
import { useTranslation } from '@eti/providers';
import ReviewModalFooter from './ReviewModalFooter';
import ReviewFlightDetails from './ReviewFlightDetails';
import ReviewModalTravelers from './ReviewModalTravelers';
import ReviewModalIncludedProducts from './ReviewModalIncludedProducts';
import ReviewModalSelectedExtraProducts from './ReviewModalSelectedExtraProducts';
import ReviewModalExtraProducts from './ReviewModalExtraProducts';
import ReviewModalChosenSeats from './ReviewModalChosenSeats';
import ReviewModalCartInformation from './ReviewModalCartInformation';

const ReviewModal = ({
  bounds,
  countries,
  discountAmount,
  extraProducts,
  form,
  includedCheckedBaggage,
  isMultiStop,
  onAdd,
  seatMap,
  selectedProducts,
  setShowReviewModal,
  shouldShow,
  totalPrice,
  travelers,
}) => {
  const { t } = useTranslation();
  const { value, ...segments } = seatMap;
  const isSeatMapSelected = value?.value === 'true';

  return (
    <Dialog
      closeButtonAriaLabel={t('ScreenReader.CloseButtonDialog.AriaLabel.Text')}
      data-testid="review-dialog"
      footer={<ReviewModalFooter form={form} />}
      isOpen={shouldShow}
      onDismiss={() => setShowReviewModal(false)}
      title={t('TravelerDetails.Review.Modal.Header.Label')}
    >
      <Stack>
        <ReviewFlightDetails bounds={bounds} isMultiStop={isMultiStop} />
        <ReviewModalTravelers
          countries={countries}
          setShowReviewModal={setShowReviewModal}
          travelers={travelers}
        />
        {isSeatMapSelected && (
          <ReviewModalChosenSeats
            bounds={bounds}
            isMultiStop={isMultiStop}
            numberOfTravelers={travelers.length}
            seatMapSegments={segments}
            setShowReviewModal={setShowReviewModal}
          />
        )}
        {includedCheckedBaggage && (
          <ReviewModalIncludedProducts includedCheckedBaggage={includedCheckedBaggage} />
        )}
        {selectedProducts.length > 0 && (
          <ReviewModalSelectedExtraProducts
            selectedProducts={selectedProducts}
            setShowReviewModal={setShowReviewModal}
          />
        )}
        {extraProducts.length > 0 && (
          <ReviewModalExtraProducts extraProducts={extraProducts} onAdd={onAdd} />
        )}
        <ReviewModalCartInformation discountAmount={discountAmount} totalPrice={totalPrice} />
      </Stack>
    </Dialog>
  );
};

ReviewModal.propTypes = {
  bounds: PropTypes.arrayOf(BoundNew),
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      label: PropTypes.string,
      phoneCountryId: PropTypes.string,
      phoneCountryPrefix: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  discountAmount: PropTypes.number,
  extraProducts: PropTypes.arrayOf(PropTypes.any),
  form: PropTypes.string,
  includedCheckedBaggage: PropTypes.shape({
    pieces: PropTypes.number,
    weight: PropTypes.number,
    weightUnit: PropTypes.string,
  }),
  isMultiStop: PropTypes.bool,
  onAdd: PropTypes.func,
  seatMap: PropTypes.shape({
    value: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
  selectedProducts: PropTypes.arrayOf(PropTypes.any),
  setIsSeatMapModalOpen: PropTypes.func,
  setShowReviewModal: PropTypes.func,
  shouldShow: PropTypes.bool,
  totalPrice: PropTypes.number,
  travelers: PropTypes.arrayOf(
    PropTypes.shape({
      ageType: PropTypes.string,
      dateOfBirth: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      mail: PropTypes.string,
      phone: PropTypes.string,
      phoneCountry: PropTypes.number,
    }),
  ),
};

export default ReviewModal;
